<template>
    <svg
        v-if="type === 'filled'"
        height="16px"
        version="1.1"
        viewBox="0 0 13 13"
        width="16px"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
    >
        <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
            <circle cx="6.5" cy="6.5" fill="#CC0030" r="6.5" />
            <path
                d="M6.2,7.9 L6,4.9 L6,2.9 L7.1,2.9 L7.1,4.9 L6.9,7.9 L6.2,7.9 L6.2,7.9 Z M6.5,10.1 C6.3,10.1 6.2,10.1 6,9.9 C5.9,9.8 5.8,9.6 5.8,9.4 C5.8,9.2 5.8,9.1 6,8.9 C6.1,8.8 6.3,8.7 6.5,8.7 C6.7,8.7 6.8,8.7 7,8.9 C7.1,9 7.2,9.2 7.2,9.4 C7.2,9.6 7.2,9.7 7,9.9 C6.9,10 6.7,10.1 6.5,10.1 Z"
                fill="#FFFFFF"
                fill-rule="nonzero"
            />
        </g>
    </svg>
    <svg
        v-else
        height="14px"
        viewBox="0 0 14 14"
        width="14px"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
            <g transform="translate(-231, -581)">
                <g transform="translate(231, 578)">
                    <g transform="translate(0, 3)">
                        <circle cx="7" cy="7" r="6.5" stroke="#CC0030" />
                        <path
                            d="M6.55785714,8.41666667 L6.36785714,5.46666667 L6.36785714,3.46666667 L7.41785714,3.46666667 L7.41785714,5.46666667 L7.22785714,8.41666667 L6.55785714,8.41666667 Z M6.88785714,10.5766667 C6.70785714,10.5766667 6.55452381,10.5133333 6.42785714,10.3866667 C6.30119047,10.26 6.23785714,10.1066667 6.23785714,9.92666667 C6.23785714,9.74666667 6.30119047,9.59333333 6.42785714,9.46666667 C6.55452381,9.34 6.70785714,9.27666667 6.88785714,9.27666667 C7.07452381,9.27666667 7.22952381,9.34 7.35285714,9.46666667 C7.47619047,9.59333333 7.53785714,9.74666667 7.53785714,9.92666667 C7.53785714,10.1066667 7.47619047,10.26 7.35285714,10.3866667 C7.22952381,10.5133333 7.07452381,10.5766667 6.88785714,10.5766667 Z"
                            fill="#CC0030"
                            fill-rule="nonzero"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
</template>
<script setup>
defineProps({ type: { type: String, default: 'outline' } });
</script>
